import { render, staticRenderFns } from "./SecSafety_SKTC.vue?vue&type=template&id=78240578&scoped=true&"
import script from "./SecSafety_SKTC.vue?vue&type=script&lang=js&"
export * from "./SecSafety_SKTC.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety_SKTC.vue?vue&type=style&index=0&id=78240578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78240578",
  null
  
)

export default component.exports